import { Link, useLocation } from "react-router-dom";
import { getCategories } from "@/lib/navData";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  const location = useLocation();
  const categories = getCategories().slice(0, 6);

  useSEO("页面未找到 - 51网址导航", "您访问的页面不存在，请返回首页或浏览热门分类。", "/404");

  return (
    <div className="max-w-page mx-auto px-4 md:px-6 py-16 md:py-24">
      <div className="flex flex-col items-center text-center">
        <span className="font-heading font-extrabold text-primary-100 text-[7rem] md:text-[10rem] leading-none select-none">
          404
        </span>
        <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950 -mt-4">
          页面未找到
        </h1>
        <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg leading-relaxed">
          抱歉，您访问的页面不存在或已被调整。当前地址：
          <span className="font-mono text-foreground-500 break-all"> {location.pathname}</span>
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="px-6 py-3 rounded-md border border-background-200 text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            搜索网址
          </Link>
        </div>

        <div className="mt-12 w-full">
          <p className="text-sm text-foreground-500 mb-4">或者从热门分类继续浏览</p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${encodeURIComponent(cat.id)}`}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={cat.icon} />
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}